import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';

export default function StatusCard({ title, value, subtitle, actionLabel, onAction, disabled }) {
  return (
    <Card sx={{ height: '100%', opacity: disabled ? 0.5 : 1 }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h6" sx={{ mb: 0.5 }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        {actionLabel && !disabled && (
          <Box sx={{ mt: 1.5 }}>
            <Button variant="text" size="small" onClick={onAction}>
              {actionLabel}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

StatusCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  disabled: PropTypes.bool,
};
